import * as Yup from 'yup';
import { DB_PREFIX_EXTRA } from './constants';

export default Yup.object().shape({
  // [DB_PREFIX_MANDATORY]: Yup.object()
  //   .shape({
  //     ...arrFieldsToKeys(
  //       mandatoryCourses,
  //       Yup.string().required('Required').nullable()
  //     ),
  //   })
  //   .required('required'),
  [DB_PREFIX_EXTRA]: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required('Please set the name of the course'),
      fileURL: Yup.string().nullable().required('required'),
    })
  ),
});
